<div class="container" *ngIf="driver && driver.jobEventShares">
  <div *ngFor="let jobEventShare of driver.jobEventShares">
    <ng-container *ngIf="showUnworkedJobs || (!showUnworkedJobs && (driver.trips | propertyFilter:'jobEventShare.id':jobEventShare.id).length > 0)">
      <div class="job">
        <div class="job-detail">
          <div class="job-heading">
            <h3>{{ jobEventShare.job }}</h3>
            <ng-container *ngIf="tripTimes[jobEventShare.jobId + jobEventShare.organizationId]">
              <div *ngIf="tripTimes[jobEventShare.jobId + jobEventShare.organizationId].start != 'Invalid Date'" translate>First Trip Start: {{ tripTimes[jobEventShare.jobId + jobEventShare.organizationId].start | date: 'h:mm a' }}</div>
              <div *ngIf="tripTimes[jobEventShare.jobId + jobEventShare.organizationId].end != 'Invalid Date'" translate>Last Trip End: {{ tripTimes[jobEventShare.jobId + jobEventShare.organizationId].end | date: 'h:mm a' }}</div>
              <div *ngIf="tripTimes[jobEventShare.jobId + jobEventShare.organizationId].end == 'Invalid Date'" translate>Last Trip End: Set Missing End Time</div>
              <div class="total-time">{{ tripTimes[jobEventShare.jobId + jobEventShare.organizationId].totalTime }}</div>
            </ng-container>
          </div>

          <div class="invoice-rate">
            <div class="column">
              <div class="value">
                {{ jobEventShare.invoiceRate | ratesCurrency : (jobEventShare.invoiceType === 'weight' ? jobEventShare.invoiceWeightUnit : jobEventShare.invoiceType) : 'USD' : 'symbol' }}
              </div>
              <div class="label" translate>Invoice Rate</div>
            </div>
            <div class="column edit">
              <div class="edit"><i class="icon-pencil" (click)="openEditShare('invoice', driver, jobEventShare)"></i></div>
            </div>
          </div>

          <div class="haul-rate">
            <div class="column">
              <div class="value">
                {{ jobEventShare.haulRate | ratesCurrency : (jobEventShare.haulType === 'weight' ? jobEventShare.haulWeightUnit : jobEventShare.haulType) : 'USD' : 'symbol' }}
              </div>
              <div class="label" translate>Haul Rate</div>
            </div>
            <div class="column edit">
              <div class="edit"><i class="icon-pencil" (click)="openEditShare('haul', driver, jobEventShare)"></i></div>
            </div>
          </div>

          <div class="actions">
            <button class="btn btn-default" (click)="openAddTrip(driver, jobEventShare)" translate>
              <i class="icon-plus"></i>
              Add Trip
            </button>
            <button 
              *ngIf="(driver?.trips | getTripsByStatusAndSharePipe: jobEventShare: 'unapproved') > 0"
              class="btn btn-primary" 
              (click)="approve(jobEventShare)" 
              translate
            >
              Approve All
            </button>
            <button 
              *ngIf="
                ((driver?.trips | getTripsByStatusAndSharePipe: jobEventShare: 'unapproved') <= 0) && 
                ((driver?.trips | getTripsByStatusAndSharePipe: jobEventShare: 'approved') > 0)" 
              class="btn btn-delete"
              (click)="unapprove(jobEventShare)" 
              translate
            >
              Unapprove All
            </button>
          </div>
        </div>
        <div class="trip-container">
          <driver-trips [trips]="driver.trips" [jobEventShare]="jobEventShare"
                        [invoiceRate]="jobEventShare.invoiceRate" [haulRate]="jobEventShare.haulRate"
                        [invoiceUnit]="jobEventShare.invoiceWeightUnit" [haulUnit]="jobEventShare.haulWeightUnit"
                        [hideApproved]="hideApproved" [showVoided]="showVoided"
                        (updateTripData)="updateTripData($event)"
                        (shouldAuditDecisions)="auditDecisions($event)"></driver-trips>
        </div>
      </div>
    </ng-container>
  </div>

  <div class="trip-container add-trip" *ngIf="!driver.trips || driver.trips.length === 0">
    <button class="btn btn-default" (click)="openAddTrip(driver)" translate>
      <i class="icon-plus"></i>
      Add Trip
    </button>
  </div>
</div>
